import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { css } from "styled-components";

paginationStyles.pagination = {
    selectProps: {
        cssOverrides: {
            formField: css`
                width: 100%;
                padding-right: 0;
                padding-top: 0;
                display: flex;
                align-items: center;
            `,
            formInputWrapper: css`
                width: auto;
            `,
            inputSelect: css`
                font-size: 12px;
                height: 30px;
                &+span {
                    padding-top: 0;
                }
            `,
        },
        labelProps: {
            css: css`
                font-size: 12px;
                font-weight: normal;
                padding-top: 2px;
                font-style: italic;
            `,
        },
    },
    cssOverrides: {
        pagination: css`
            margin: 0 !important;
            height: auto important;
            width: 100%;
            justify-content: space-between;
            height: auto !important;
        `,
    },
};
